import {
  Autocomplete,
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { MuiTelInput } from 'mui-tel-input';
import { getToast } from '../../../utils/toastConfig';

function ModalC(props) {
  const {
    clientModalCreateString,
    clientMCGeneralString,
    clientMCGBusinessNString,
    clientMCContactString,
    clientMCCompanyNameString,
    clientMCCEmailString,
    clientMCCNameString,
    clientMCCLastNameString,
    clientMCCPasswordString,
    clientMCCRPasswordString,
    saveString,
    pwTooltipString,
    phoneCountryStr,
    notesString,
  } = useTranslationHook();

  const weakPWErrorAlert = (missingRequirements) => {
    toast.dismiss();
    if (missingRequirements.length > 0) {
      toast.error(
        'La contraseña ingresada es débil. No cumple con los siguientes requisitos:',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );

      missingRequirements.forEach((requirement) => {
        toast.info(`${requirement}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.show) {
      fetchRegions();
    }
  }, [props.show]);

  const fetchRegions = async () => {
    customAxios
      .get(`${GlobalVariables.getURL()}region/`, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        setRegions(response.data.data);
      })

      .catch((error) => console.log(error));
  };

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [haveAccess, setHaveAccess] = useState(false);
  const [password, setPW] = useState('');
  const [verifyPassword, setVPW] = useState('');
  const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('MX');

  const [notes, setNotes] = useState('');

  const [business, setBusiness] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [rfc, setRFC] = useState('');

  const hide = () => {
    props.onHide();
    toast.dismiss();
    getToast({
      status: 'success',
      title: 'Plaza creada exitosamente en la base de datos.',
    });
    props.getClients();
  };

  const createClient = (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (password === verifyPassword) {
      const requestData = {
        // name: name,
        // last_names: lastName,
        // email: email,
        // telefono: phone,
        // countryCode: countryCode,
        business_name: business,
        // rfc: rfc,
        // company_name: companyName,
        region_id: selectedRegion,
        // notes,
        // roles_id: 10,
      };

      if (password !== '') {
        requestData.password = password;
      }

      customAxios
        .post(`${GlobalVariables.getURL()}createClient`, requestData, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then(
          (response) => {
            hide();
          },
          (error) => {
            console.log(error);
            const errorMessage = error.response.data.message;

            if (errorMessage === 'Cliente ya existe.') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'Ya existe una Plaza con esta información. Vuelve a intentarlo.',
              });
            } else if (
              errorMessage === 'Licencias insuficientes para el rol Client'
            ) {
              toast.dismiss();
              getToast({
                status: 'error',
                title: 'Licencias insuficientes para el rol Client',
              });
            } else if (errorMessage === 'Usuario ya existe.') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'Ya existe un usuario con esta información. Vuelve a intentarlo.',
              });
            } else if (errorMessage.startsWith('Contraseña débil.')) {
              const requirements = [
                'Debe contener al menos una letra mayúscula.',
                'Debe contener al menos un número.',
                'Debe contener al menos un caracter especial (!@#$%^&*).',
                'Debe tener al menos 9 caracteres de longitud.',
              ];

              const missingRequirements = requirements.filter((requirement) =>
                errorMessage.includes(requirement)
              );

              weakPWErrorAlert(missingRequirements);
            } else {
              toast.dismiss();
              getToast({
                status: 'error',
                title: 'Error al crear Plaza. Vuelve a intentarlo.',
              });
            }
          }
        )
        .finally(() => setIsLoading(false));
    } else {
      toast.dismiss();
      getToast({
        status: 'error',
        title: 'Contraseñas no coinciden. Vuelve a intentarlo.',
      });
      setIsLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {clientModalCreateString}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="clients-form" onSubmit={createClient}>
          {/* <Divider className='mui-dividers'>{clientMCGeneralString}</Divider>
          <br /> */}

          <div className="row">
            <div className="col-md-12">
              <TextField
                fullWidth
                label={'Nombre de la Plaza'}
                placeholder={'Nombre de la Plaza'}
                type="text"
                value={business}
                onChange={(e) => setBusiness(e.target.value)}
                required
              />
            </div>
            {/* <div className='col-md-6'>
              <TextField
                fullWidth
                label='RFC'
                type='text'
                value={rfc}
                onChange={(e) => setRFC(e.target.value)}
                required
              />
            </div> */}
          </div>
          <br />

          <div className="row">
            {/* <div className='col-md-6'>
              <TextField
                sx={{ width: '100%' }}
                label={clientMCCompanyNameString}
                type='text'
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
            </div> */}
            <div className="col-md-12">
              <Autocomplete
                options={regions}
                value={regions.find((i) => i.id === selectedRegion) || null}
                getOptionLabel={(i) => i.name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(_, newValue) => {
                  setSelectedRegion(newValue ? newValue.id : null);
                }}
                renderInput={(params) => (
                  <TextField
                    disabled={isLoading}
                    required
                    {...params}
                    label={'Región'}
                    placeholder={'Región...'}
                  />
                )}
              />
            </div>
          </div>

          {/* <br /> */}
          {/* <div className='create-client-contact-form-tour'>
            <Divider className='mui-dividers'>{clientMCContactString}</Divider>
            <br />

            <div className='row'>
              <div className='col-md-6'>
                <TextField
                  sx={{ width: '100%' }}
                  label={clientMCCEmailString}
                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className='col-md-6'>
                <MuiTelInput
                  sx={{ width: '100%' }}
                  label='Teléfono'
                  defaultCountry={countryCode}
                  langOfCountryName={phoneCountryStr}
                  value={phone}
                  onChange={(newPhone, info) => {
                    setPhone(newPhone);
                    setCountryCode(info.countryCode);
                  }}
                  forceCallingCode
                  disableFormatting
                  required
                />
              </div>
            </div>

            <br />

            <div className='row'>
              <div className='col-md-5'>
                <TextField
                  sx={{ width: '100%' }}
                  label={clientMCCNameString}
                  type='text'
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className='col-md-5'>
                <TextField
                  sx={{ width: '100%' }}
                  label={clientMCCLastNameString}
                  type='text'
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
              <div className='col-md-2'>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={haveAccess}
                      onChange={() => {
                        setHaveAccess(!haveAccess);
                        setPW('');
                        setVPW('');
                      }}
                    />
                  }
                  label='¿Tendrá acceso?'
                />
              </div>
            </div>

            <br />

            {haveAccess && (
              <>
                <div className='row'>
                  <div className='col-md-6'>
                    <Tooltip title={pwTooltipString} arrow>
                      <TextField
                        sx={{ width: '100%' }}
                        label={clientMCCPasswordString}
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPW(e.target.value)}
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                onClick={handleClickShowPassword}
                                edge='end'
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword ? (
                                  <VisibilityOffOutlinedIcon />
                                ) : (
                                  <VisibilityOutlinedIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Tooltip>
                  </div>
                  <div className='col-md-6'>
                    <Tooltip title={pwTooltipString} arrow>
                      <TextField
                        sx={{ width: '100%' }}
                        label={clientMCCRPasswordString}
                        type={showPassword ? 'text' : 'password'}
                        value={verifyPassword}
                        onChange={(e) => setVPW(e.target.value)}
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                onClick={handleClickShowPassword}
                                edge='end'
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword ? (
                                  <VisibilityOffOutlinedIcon />
                                ) : (
                                  <VisibilityOutlinedIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
                <br />
              </>
            )}
            <div className='row'>
              <div className='col-md-12'>
                <TextField
                  sx={{ width: '100%' }}
                  label={notesString}
                  type={'text'}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
            </div>
          </div> */}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="submit"
          form="clients-form"
          className="save-modal-button"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size="2rem" />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalC;
